import React from 'react' // eslint-disable-line
import styled from 'styled-components'

const Heading1 = styled.h1`
  font-size: 4.5rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
`

const TextLG = styled.span`
  font-size: 2.2rem;
  font-family: 'Poppins', sans-serif;
`

const TextMD = styled.span`
  font-size: 1.4rem;
  font-family: 'Poppins', sans-serif;
`

const TextSM = styled.span`
  font-size: 1.2rem;
  font-family: 'Poppins', sans-serif;
`

const TextXS = styled.span`
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
`

export { Heading1, TextLG, TextMD, TextSM, TextXS }



// WEBPACK FOOTER //
// ./src/components/Common/Typography.js